const $ = jQuery.noConflict();
/* eslint-disable */
'use strict';
const Filters = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		$('<span class="filters-radio-btn"></span>').appendTo($('.js-price-range-radio-custom label'));
		$('.js-price-range-radio-custom label').wrapAll('<div class="price-range-radio-custom-labels"></div>');
		$('.sf-field-taxonomy-brand h4').on('click', function() {
			$('.sf-field-taxonomy-brand h4').toggleClass('is-active');
			$('.sf-field-taxonomy-brand ul').slideToggle();
		});
		$('.js-price-range-radio-custom h4').on('click', function() {
			$('.js-price-range-radio-custom h4').toggleClass('is-active');
			$('.price-range-radio-custom-labels').slideToggle();
		});
		if ($(window).width() < 992) {
			$('.product-categories-holder span').on('click', function() {
				$('.product-categories-holder span').toggleClass('is-active');
				$('.product-categories-holder ul').slideToggle();
			});
			$('.product-categories-holder span').trigger('click');
		}
	},
};

export default Filters;
